"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createColors_1 = require("./createColors");
/**
 * Create colors with specified color map.
 */
function createColorsFromMap(colormap, shades, alpha) {
    if (shades < colormap.length) {
        throw new Error("Requires at least " + colormap.length + " shades.");
    }
    var result = [];
    var steps = [];
    for (var i = 0; i < colormap.length; i++) {
        steps.push(Math.round(colormap[i].index * shades));
    }
    for (var i = 0; i < colormap.length - 1; i++) {
        var n = steps[i + 1] - steps[i];
        var from = colormap[i].rgb;
        var to = colormap[i + 1].rgb;
        result.push.apply(result, createColors_1.createColors(from, to, n, alpha));
    }
    return result;
}
exports.createColorsFromMap = createColorsFromMap;
//# sourceMappingURL=createColorsFromMap.js.map


//////////////////
// WEBPACK FOOTER
// ./~/color-map/dist-es5/createColorsFromMap.js
// module id = 579
// module chunks = 0